export function isRateLimitError(error: unknown): boolean {
  const anyErr = error as any

  const status = anyErr?.status ?? anyErr?.statusCode ?? anyErr?.response?.status
  if (typeof status === "number" && status === 429) return true

  const message = String(anyErr?.message ?? anyErr?.toString?.() ?? "")
  return message.includes("429") || message.toLowerCase().includes("rate limit")
}
